export const AppConfig = {
    //CASO TRUE e for um novo projeto back-end AppsScript, realizar ao menos uma primeira implantação para liberar acesso DEV.
    DEV_MODE: false,


    //TESTE
    ///GAS_URL_DEV: "https://script.google.com/macros/s/AKfycbxwmWHmVTOESqlQN4xZalXvhLruIdDTK28PGQoQYxI/dev?dev=true",
    //GAS_URL_EXEC: "https://script.google.com/a/macros/academico.ifpb.edu.br/s/AKfycbx1bphQqFCQjqKXnSi7d3WyHBX1C1ukG1ma32QA4doH4aC5kN7TgTKyaDE_60TI_7ha/exec?exec=true",



    //GAS WEBAPP DEVELOPMENT (PASTA AVIN DESENVOLVIMENTO NO DRIVE DO PROJETO)
    //GAS_URL_DEV: "https://script.google.com/macros/s/AKfycbw4uZ8Mxuun7oOSHONDXRBw4eveBgc9N85tBaOJjf4/dev?dev=true",
    GAS_URL_EXEC: "https://script.google.com/a/macros/academico.ifpb.edu.br/s/AKfycbz6_ooEx_AP9nsvQH0pVwrbKM7HJ7I1RoTW2JomPfi04ijGeJP9y1k7d4r6-j5lGGdL/exec?exec=true",

    //DEMAIS PARÂMETROS
    GAS_URL_ACCOUNT_CHOOSER: "https://accounts.google.com/AccountChooser/signinchooser?flowName=GlifWebSignIn&flowEntry=AccountChooser&continue=",
    CPA_EMAIL: 'avaliacao@ifpb.edu.br',
    CPA_URL: 'https://ifpb.edu.br/cpa',

    //Dominios para verificações posteriores
    DOMAINS_IFPB: ["academico.ifpb.edu.br", "ifpb.edu.br"]
}


AppConfig.GAS_URL_DEV += encodeURIComponent(`&urlUI=${window.location.origin}`);
AppConfig.GAS_URL_EXEC += encodeURIComponent(`&urlUI=${window.location.origin}`);